//created by sudip
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { fadeInUp } from "@/animations/motion";

interface MarketingIllustrationProps {
  src: string;
  alt: string;
  accent?: string;
  className?: string;
}

export default function MarketingIllustration({
  src,
  alt,
  accent = "#0F8B8D",
  className,
}: MarketingIllustrationProps) {
  return (
    <motion.div
      variants={fadeInUp(0.15)}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      className={cn(
        "relative mx-auto w-full max-w-[680px]",
        className,
      )}
    >
      {/* Background Glow */}

      <div
        className="absolute inset-10 -z-10 rounded-full opacity-50 blur-[120px]"
        style={{
          background: accent,
        }}
      />

      {/* Decorative Circles */}

      <motion.div
        animate={{ y: [0, -10, 0] }}
        transition={{
          duration: 6,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        className="absolute -left-6 top-16 h-5 w-5 rounded-full bg-primary/40"
      />

      <motion.div
        animate={{ y: [0, 10, 0] }}
        transition={{
          duration: 5,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        className="absolute -right-4 top-10 h-3 w-3 rounded-full bg-cyan-400/70"
      />

      <motion.div
        animate={{ y: [0, -10, 0] }}
        transition={{
          duration: 7,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        className="absolute -right-5 bottom-20 h-4 w-4 rounded-full bg-primary/30"
      />

      {/* Glass Card */}

      {/* <div className="relative overflow-hidden rounded-[32px] border border-border/60 bg-card/90 p-8 shadow-[0_30px_80px_rgba(15,23,42,0.12)] backdrop-blur-xl">
        <img src={src} alt={alt} className="w-full object-contain" />
      </div> */}
      <div className="relative overflow-hidden rounded-[32px] border border-border bg-card shadow-[0_40px_100px_-40px_rgba(15,23,42,0.35)]">
        <img src={src} alt={alt} className="w-full h-full object-contain rounded-[32px]" />
      </div>
    </motion.div>
  );
}